import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center p-6">
      <div className="animate-page-enter text-center">
        <p className="text-muted-foreground text-sm font-medium tracking-widest uppercase">
          404
        </p>
        <h1 className="mt-3 text-2xl">That page doesn&apos;t exist.</h1>
        <Button asChild className="mt-6">
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </div>
  );
}
